import { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { SoundButton, SoundModal } from "@/shared/ui";
import { ModalProps } from "@/shared/ui/modal/Modal";

type Props = {
  onChangeSig: ({ sigUrl, sigBlob }: { sigUrl: string; sigBlob: Blob }) => void;
  pending?: boolean;
} & ModalProps;

export default function SigModal({ onClose, onChangeSig, pending, ...rest }: Props) {
  const sigCanvas = useRef<SignatureCanvas | null>(null);

  const uploadSignature = async () => {
    if (!sigCanvas.current || sigCanvas.current.isEmpty()) return;

    // Получаем изображение в формате WebP
    const dataUrl = sigCanvas.current.toDataURL("image/webp");

    // Преобразуем dataURL в Blob
    const blob = await (await fetch(dataUrl)).blob();

    // Передаём наружу: и ссылку (для предпросмотра), и blob (для отправки на сервер)
    onChangeSig({ sigUrl: dataUrl, sigBlob: blob });

    try {
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <SoundModal open title="Распишитесь" className="w-fit" onClose={onClose} {...rest}>
      <div className="flex flex-col items-center">
        <SignatureCanvas
          penColor="black"
          canvasProps={{
            width: 400,
            height: 150,
            className: "sigCanvas rounded-[0.5rem] bg-white",
          }}
          ref={sigCanvas}
        />
      </div>
      <div className="grid grid-cols-2 gap-2.5 mt-[2rem]">
        <SoundButton
          className="h-[2.5rem]"
          onClick={uploadSignature}
          loading={pending}
          disabled={pending}
        >
          Сохранить
        </SoundButton>
        <SoundButton
          className="h-[2.5rem]"
          color="gray"
          variant="soft"
          onClick={() => sigCanvas.current?.clear()}
          disabled={pending}
        >
          Очистить
        </SoundButton>
      </div>
    </SoundModal>
  );
}
